<template>
  <li
    id="listbox-item-0"
    role="option"
    class="text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9 hover:bg-indigo-100 hover:text-indigo-600"
  >
    <div class="flex items-center space-x-3">
      <!-- Selected: "font-semibold", Not Selected: "font-normal" -->
      <span class="font-normal block truncate">
        <slot />
      </span>
    </div>

    <!--
            Checkmark, only display for selected option.

            Highlighted: "text-white", Not Highlighted: "text-indigo-600"
          -->
    <span class="absolute inset-y-0 right-0 flex items-center pr-4">
      <!-- Heroicon name: check -->
      <!-- <Icon name="Check" class="h-5 w-5" /> -->
    </span>
  </li>
</template>

<script>
// import Icon from "@/components/UI/Icon";
export default {
  // components: { Icon },
};
</script>

<style></style>
